export enum CustomerClassificationEnum {
  denied = "0",
  known = "1",
  mini = "2",
  miniPlus = "3",
  regular = "4",
  knownMiniPlus = "5",
}

export interface CustomerClassification {
  customer_classification: CustomerClassificationEnum;
  require_documentation: boolean;
  require_labor_data: boolean;
  require_secure_payment: boolean;
  require_address_data: boolean;
  require_enrichment_personal_finances?: boolean;
}
